class KeywordTrackers {

  constructor(basePath, apiClient) {

    this.basePath = `${basePath}/keyword-trackers`;
    this.apiClient = apiClient;

  }

  async getKeywordTrackers() {

    const path = this.basePath;

    return this.apiClient.get(path, {}, {});

  }

  async countKeywordTrackers() {

    const path = this.basePath;

    return this.apiClient.get(`${path}/count`, {}, {});

  }

  async discoverKeywords(data) {

    const path = `${this.basePath}/discover`;

    return this.apiClient.post(path, {}, {}, data);

  }

  async getRecentDiscoveries() {

    const path = `${this.basePath}/discoveries`;

    return this.apiClient.get(path, {}, {});

  }

  async createKeywordTracker(data) {

    const path = this.basePath;

    return this.apiClient.post(path, {}, {}, data);

  }

  async updateKeywordTracker(trackerId, data) {

    const path = this.basePath + '/:trackerId';

    return this.apiClient.put(path, { trackerId }, {}, data);

  }

  async deleteKeywordTracker(trackerId) {

    const path = this.basePath + '/:trackerId';

    return this.apiClient.delete(path, { trackerId }, {});

  }

}

export default KeywordTrackers;
